import { date } from 'quasar'
import ActivitySession from 'src/models/activity-session/ActivitySession'
import Model, { ID, IsoDateTime } from 'src/models/model'
import { START_HOUR, timeToMinutes } from 'src/models/schedule/TimeSlot'

export const hoursPerDay = 24
export const minutesPerHour = 60

export const innerItemHeight = 90
export const yMargin = 10
export const totalItemHeight = innerItemHeight + yMargin

export const headerHeight = 60

export const defaultMovieMinutes = 90
export const defaultCleanUpMinutes = 10
export const defaultPreviewMinutes = 10

export default class ScheduleSlot extends Model {
  static name = 'ScheduleSlot'

  static employeeRequiredPermissionCategories = [Model.permissionCategories.NonFilmProgramming]

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      activitySession: {
        type: ActivitySession,
        reference: true
      },
      currentSelection: {
        type: Boolean,
        default: false,
        local: true
      },
      finalSelection: {
        type: Boolean,
        default: false,
        local: true
      },
      ghostSlot: {
        type: Boolean,
        default: false,
        local: true
      }
    }

    this.computed = {
      selected () {
        return this.currentSelection || this.finalSelection
      },
      height () {
        return innerItemHeight
      },
      top () {
        let top

        const activitySpaceIndex = this.activitySession.activitySchedule.activitySpaceIndex(this.activitySession.activitySpace.id)
        const dayIndex = this.activitySession.activitySchedule.dayIndex(this.activitySession.dayNumber)

        const activitySpaceCount = this.activitySession.activitySchedule.filteredActivitySpaces.length
        const resourceGraphHeight = this.activitySession.activitySchedule.resourceGraphHeight

        if (this.activitySession.activitySchedule.by === 'screen') {
          top = headerHeight + activitySpaceIndex * 7 * totalItemHeight + dayIndex * totalItemHeight + yMargin
        } else {
          top = headerHeight +
            activitySpaceIndex * totalItemHeight +
            dayIndex * (totalItemHeight * activitySpaceCount + resourceGraphHeight) +
            resourceGraphHeight +
            yMargin
        }

        if (this.overlaps) {
          top += 10
        }

        return top
      },
      left () {
        const left = this.startTimeMinutes * this.activitySession.activitySchedule.pixelsPerMinute
        return left
      },
      width () {
        return this.totalDurationMinutes * this.activitySession.activitySchedule.pixelsPerMinute
      },
      startTime () {
        return date.formatDate(this.activitySession.siteStartTime, 'h:mmA').slice(0, -1)
      },
      endTime () {
        return date.formatDate(this.activitySession.siteEndTime, 'h:mmA').slice(0, -1)
      },
      startTimeMinutes () {
        return timeToMinutes(this.activitySession.siteStartTime)
      },
      endTimeMinutes () {
        return timeToMinutes(this.activitySession.siteEndTime)
      },
      totalDurationMinutes () {
        return this.endTimeMinutes - this.startTimeMinutes
      }
    }
  }

  createActivitySession () {
    const newActivitySession = new ActivitySession({
      activity: this.activitySession.activity,
      activitySchedule: this.activitySession.activitySchedule,
      activitySpace: this.activitySession.activitySpace,
      startTime: this.activitySession.startTime,
      endTime: this.activitySession.endTime
    })

    if (this.activitySession.activity.sessionDurationMinutes === 0) {
      newActivitySession.endTime = new IsoDateTime(date.addToDate(this.activitySession.activitySchedule.startDate,
        { hours: START_HOUR, minutes: this.activitySession.timeSlot.endTimeMinutes - this.activitySession.activity.sessionBufferMinutes }
      ))
    }

    return newActivitySession
  }
}
